import React from 'react';
import ConfigurationBlock from './ConfigurationBlock';

const ConfigurationBlockList = ({
	configurationData,
	selectedItems,
	handleClickOnSort,
	handleSelected,
}) => {
	return (
		<ul className="configuration_block_list">
			{configurationData.map(
				(
					{
						code,
						reference,
						buildingReference,
						lastEdited,
						created,
						lastEditedUserEmail,
						lastEditedUserId,
						amountGlassTypes,
						type,
						status,
						uploadedDocuments,
					},
					index
				) => {
					return (
						<li className="configuration_block_list__item" key={code}>
							<ConfigurationBlock
								code={code}
								reference={reference}
								buildingReference={buildingReference}
								amountGlassTypes={amountGlassTypes}
								lastEditedUserEmail={lastEditedUserEmail}
								lastEditedUserId={lastEditedUserId}
								created={created}
								lastEdited={lastEdited}
								type={type}
								status={status}
								uploadedDocuments={uploadedDocuments}
								fullConfiguration={configurationData[index]}
								handleClickOnSort={handleClickOnSort}
								handleSelected={handleSelected}
								isSelected={selectedItems[code] !== undefined}
							/>
						</li>
					);
				}
			)}
		</ul>
	);
};

export default ConfigurationBlockList;
